<template>
  <el-dialog
    :title="type === 'edit'?'编辑':'新增'"
    :visible.sync="dialog"
    :width="getIsMobile?'100%':'50%'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="100px" :label-position="getIsMobile?'top':'right'" :rules="rules"
             class="custom-form">
      <el-form-item label="分类名称" prop="classname">
        <el-input v-model="form.classname" placeholder="请输入分类名称"></el-input>
      </el-form-item>
      <el-form-item label="加价幅度" prop="jjfd">
        <el-input v-model="form.jjfd" placeholder="请输入加价幅度"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleReset">重 置</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref, watch } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'

export default defineComponent({
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(props, { emit }) {
    const { getIsMobile } = useRootSetting()
    const formRef = ref(null)
    const rules = {
      classname: [
        { required: true, message: '分类名称不能为空', trigger: 'blur' }
      ],
      jjfd: [
        { required: true, message: '加价幅度不能为空', trigger: 'blur' }
      ]
    }

    const radio = ref(1)
    const defaultForm = () => ({
      classname: '',
      jjfd: ''
    })
    const form = reactive(defaultForm())

    watch(() => props.formData, (val) => {
      Object.keys(val).forEach((key) => {
        if (key in form) {
          form[key] = val[key]
        }
      })
    })

    const handleReset = () => {
      Object.assign(form, defaultForm())
    }

    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form)
        }
      })
    }

    const handleClose = () => {
      emit('close')
      Object.assign(form, defaultForm())
      handleReset()
    }
    return {
      getIsMobile,
      formRef,
      form,
      rules,
      radio,
      handleReset,
      handleSubmit,
      handleClose
    }
  }
})
</script>
